import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls

export const fetchCardData = createAsyncThunk("fetchCardData", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.cardDetails}?period=${data.period}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.cardDetails} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});

export const fetchPurchaseReqGraph = createAsyncThunk("fetchPurchaseReqGraph", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.purchaseRequestGraph}?period=${data.period}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.purchaseRequestGraph} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});

export const fetchCallReqGraph = createAsyncThunk("fetchCallReqGraph", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.callRequestGraph}?period=${data.period}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.callRequestGraph} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});

export const fetchMaintenanceReqGraph = createAsyncThunk("fetchMaintenanceReqGraph", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.maintenanceRequestGraph}?period=${data.period}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.maintenanceRequestGraph} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});

export const fetchFARGraph = createAsyncThunk("fetchFARGraph", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.FARGraph}?period=${data.period}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.FARGraph} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});

export const fetchConsultationReqGraph = createAsyncThunk("fetchConsultationReqGraph", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.consultationRequestGraph}?period=${data.period}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.FARGraph} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});

export const fetchConditionMonitoringGraph = createAsyncThunk("fetchConditionMonitoringGraph", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.conditionMonitoringRequestGraph}?period=${data.period}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.FARGraph} ====> ${JSON.stringify(
        response?.data
      )}`
    );
  }
  return response?.data;
});


export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {

    builder
      .addCase(fetchCardData.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCardData.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCardData.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCallReqGraph.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCallReqGraph.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCallReqGraph.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchPurchaseReqGraph.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchPurchaseReqGraph.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchPurchaseReqGraph.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchMaintenanceReqGraph.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchMaintenanceReqGraph.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchMaintenanceReqGraph.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchFARGraph.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchFARGraph.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchFARGraph.rejected, (state, action) => {
        state.isLoading = "failed";
      });


  },
});

export default dashboardSlice.reducer;
